__webpack_require__.p = "/_ui/project/global/";